export default {
  own: 1, //本人，仅能查看自己的数据
  department: 2, //本部门，能查看所在部门所有成员数据
  departmentAndSub: 3, //本部门及下级部门，能查看所在部门及其下级部门所有成员的数据
  all: 4, //全公司，能查看本公司所有成员的数据
  departmentOwnAndSub: 5, //主管部门及下级部门，能查看作为部门管理员所在部门及其下级部门成员的数据，但同级部门管理员的数据除外
  departmentUnionOwnAndSub: 6, //当同时拥有2和5的可见范围时，需要根据是否是部门管理员来判断可见范围，后端返回6
}
